import React from "react";
import { useNavigate } from "react-router-dom";
import { Dropdown, Tooltip } from "antd";
import { EllipsisOutlined } from "@ant-design/icons";
import { organizerUseMutation } from "../hooks";
import OrganizerConst from "../organizer-const";
import { EntityRemoveButton, Localize } from "components/service";
import { localizeByKey } from "components/service/localize";
import type { TOrganizer } from "components/organizer/helpers/organizer-types-helper";
import Icons from "components/icons";
import { usePermissionByObject, useModelFormValidation } from "components/permissions";
import Organizers from "components/organizer";


interface IOrganizerActionFieldProps
{
  organizer: TOrganizer | undefined;
}


const OrganizerActionField: React.FC<IOrganizerActionFieldProps> = ({ organizer }) =>
{
  const navigate = useNavigate();

  const { _setMutationOrganizerDelete, loadingMutationOrganizerDelete } =
    organizerUseMutation.delete(organizer?.id);

  const { hasPermission: hasUpdatePermission } = usePermissionByObject(Organizers.Const.permissions.UPDATE);
  const { hasPermission: hasDeletePermission } = usePermissionByObject(Organizers.Const.permissions.DELETE);
  const { validateDeletePermission } = useModelFormValidation(Organizers.Const);

  const items = [
    {
      label: (
        <Tooltip title={!hasUpdatePermission ? localizeByKey('PERMISSION.Error_AccessDenied') : ''}>
          <span style={{ display: "flex", alignItems: "center", width: 100 }}>
            <Icons.Edit /> <Localize>MENUS_DROP.Label_Edit</Localize>
          </span>
        </Tooltip>
      ),
      key: "1",
      disabled: !hasUpdatePermission,
      onClick: () => {
        if (!hasUpdatePermission) return;
        navigate(`${OrganizerConst.basePath}/${organizer?.id}/`);
      },
    },
    {
      key: "2",
      label: (
        <Tooltip title={!hasDeletePermission ? localizeByKey('PERMISSION.Error_AccessDenied') : ''}>
          <EntityRemoveButton
            modalButton={
              <span style={{ display: "flex", alignItems: "center", width: 100 }}>
                <Icons.Delete /> <Localize>MENUS_DROP.Label_Delete</Localize>
              </span>
            }
            nameEntity={
              localizeByKey("ENTITY.Modal_Title_Organizer")
            }
            dataNameEntity={organizer?.title}
            loading={loadingMutationOrganizerDelete}
            deleteMutation={(options) => {
              if (!validateDeletePermission()) {
                return Promise.reject(new Error('Access denied'));
              }
              return _setMutationOrganizerDelete(options);
            }}
            variables={{
              id: organizer?.id,
            }}
          />
        </Tooltip>
      ),
      disabled: !hasDeletePermission,
    },
  ];

  return (
    <Dropdown
      // trigger={['click']}
      placement="bottomRight"
      menu={{ items }}
      overlayClassName="drop-more-menu"
      arrow
    >
      <EllipsisOutlined className="btn-more" />
    </Dropdown>
  );
};

export default OrganizerActionField;
